import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Link } from 'react-router-dom';
import TicketedEventsList from '../../components/TicketedEvents/List';
import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import ShowFor from '@Components/ShowFor';

export default function TicketedEvents() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Events', href: '/events' },
          { name: 'Ticketed Events', href: '/ticketed-events' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Ticketed Events</Heading>
        </div>

        <ShowFor permissions={['EVENTS_WRITE']}>
          <Button variant="primary" asChild>
            <Link to="/ticketed-events/create">Create new event</Link>
          </Button>
        </ShowFor>
      </div>
      <TicketedEventsList />
    </div>
  );
}
